var _defs, _rect, _rect2, _path, _circle, _use, _use2, _use3, _use4, _use5, _use6, _use7, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "s"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "t",
    d: "M 0,-1 v 1 h .5",
    transform: "rotate(18 0,-1)",
    fill: "#fcd116"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    transform: "scale(-1,1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(144)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(216)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(288)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 300,
    fill: "#ce1126"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 42,
    width: 416,
    height: 216,
    fill: "#007a5e"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 42,42 h 416 l -416,216 h 416 z",
    fill: "#fcd116"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 150,
    r: 36,
    fill: "#ce1126"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "translate(250,150) scale(33)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s2",
    x: -100
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    id: "s2",
    xlinkHref: "#s",
    transform: "translate(250,21) scale(19.5)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s2",
    x: 100
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s2",
    x: -100,
    y: 258
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s2",
    y: 258
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s2",
    x: 100,
    y: 258
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 67.749,150.41 c 4.504,8.39 13.265,17.52 20.916,20.73 c .123,-8.52 -2.9,-19.44 -7.034,-28.14 l -13.882,7.41 z",
    fill: "#ce1126"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 60.112,121.63 c 6.529,13.61 -16.933,46.08 22.156,53.69 c -4.822,-6.58 -7.931,-17.44 -6.755,-26.16 c 8.201,3.12 16.83,12.25 20.317,19.23 c 10.23,-37.15 -26.24,-34.89 -35.718,-46.76 z",
    fill: "#fcd116"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGd);
export default __webpack_public_path__ + "static/media/gd.7391bfd04c3b1d608f97d4d7ceb12bd7.svg";
export { ForwardRef as ReactComponent };